import { useState } from "react";
import { toast } from "sonner";
import { XCircle, MessageCircle, Check } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BigButton } from "@/components/Field";
import { TextArea } from "@/components/Bits";
import { api, errMsg } from "@/lib/api";

const MOTIVOS = [
  { value: "sem_acesso", label: "Local sem acesso" },
  { value: "cliente_resolveu", label: "Cliente já resolveu o problema" },
  { value: "outro", label: "Outro motivo" },
];

export const NaoConcluirButton = ({ os, onDone, showButton }) => {
  const [open, setOpen] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [detalhe, setDetalhe] = useState("");
  const [notify, setNotify] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/ordens/${os.os_id}/nao-concluir`, { motivo, detalhe });
      setOpen(false);
      onDone(data.os);
      setNotify(data);
      toast.success("OS encerrada sem sucesso");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const sendWpp = () => {
    window.open(`https://wa.me/${notify.telefone || ""}?text=${encodeURIComponent(notify.mensagem)}`, "_blank");
    setNotify(null);
  };

  return (
    <>
      {showButton && <button onClick={() => setOpen(true)} data-testid="os-nao-concluir-button"
        className="h-14 w-full rounded-xl border-2 border-[#B05A40] text-[#B05A40] bg-white font-semibold flex items-center justify-center gap-2 hover:bg-[#C86D51]/10">
        <XCircle className="h-5 w-5" /> Encerrar sem sucesso
      </button>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-3xl" data-testid="nao-concluir-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Não foi possível concluir</DialogTitle></DialogHeader>
          <p className="-mt-2 text-sm text-[#5C6B66]">A OS será encerrada <b>sem custo para o cliente</b> e o administrador será avisado.</p>
          <div className="space-y-2">
            {MOTIVOS.map((m) => (
              <button key={m.value} type="button" onClick={() => setMotivo(m.value)} data-testid={`motivo-${m.value}`}
                className={`min-h-[56px] w-full rounded-xl border-2 px-4 flex items-center gap-3 text-left font-semibold ${motivo === m.value ? "border-[#B05A40] bg-[#F5E6E0]" : "border-[#E2DDD3]"}`}>
                <span className={`h-6 w-6 rounded-full border-2 flex items-center justify-center ${motivo === m.value ? "bg-[#B05A40] border-[#B05A40] text-white" : "border-[#C9C2B4]"}`}>{motivo === m.value && <Check className="h-4 w-4" />}</span>
                {m.label}
              </button>
            ))}
          </div>
          <TextArea label={motivo === "outro" ? "Descreva o motivo *" : "Detalhes (opcional)"} id="nc-det" value={detalhe} onChange={(e) => setDetalhe(e.target.value)} data-testid="nao-concluir-detalhe" />
          <BigButton onClick={submit} disabled={busy || !motivo || (motivo === "outro" && !detalhe.trim())} className="!bg-[#B05A40]" data-testid="nao-concluir-confirm">Confirmar encerramento</BigButton>
        </DialogContent>
      </Dialog>
      <Dialog open={!!notify} onOpenChange={(o) => !o && setNotify(null)}>
        <DialogContent className="max-w-md rounded-3xl" data-testid="nao-concluir-notify-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Avisar o administrador</DialogTitle></DialogHeader>
          <p className="-mt-2 text-sm text-[#5C6B66] whitespace-pre-line">{notify?.mensagem}</p>
          <button onClick={sendWpp} data-testid="nao-concluir-whatsapp" className="h-14 rounded-xl bg-[#25D366] text-white font-semibold flex items-center justify-center gap-2"><MessageCircle className="h-5 w-5" /> Enviar aviso no WhatsApp</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
